import { Component, Input, OnInit } from '@angular/core';
import { FuelEnum, TransmissionEnum, Vehicle } from '@app-model/vehicle';
import { CountDownService, CountDownTime } from '@app-services/count-down.service';
import { DealerService } from '@app-services/dealer.service';
import { OpenService } from '@app-services/open.service';
import { FipeComparisonMode } from '@app-utils/fipe-comparison.utils';
import { SessionService } from '@app/store/session/session.service';
import { UserInfo } from '@app/store/session/session.store';

@Component({
  selector: '[app-card-vehicle-home]',
  templateUrl: './card-vehicle-home.component.html',
  styleUrls: ['./card-vehicle-home.component.scss']
})
export class CardVehicleHomeComponent implements OnInit {

  private static readonly IMAGE_URL_PATTERN = /\.(png|jpe?g|webp)(\?|$)/i;

  @Input() vehicle: Vehicle;
  @Input() ownsVehicle: boolean;
  @Input() isFastQuote: boolean;
  @Input() gridMode?: boolean;

  contador: CountDownTime;
  user: UserInfo;

  imgIndex = 0;
  vehicleImages: string[] = [];
  imgUrls: string[] = [];
  readonly FipeComparisonMode = FipeComparisonMode;

  constructor(
    private countDownService: CountDownService,
    private dealerService: DealerService,
    private openService: OpenService,
    private sessionService: SessionService,
  ) { }

  ngOnInit(): void {
    this.sessionService.getUser().subscribe(u => {
      this.user = u;
    });

    this.countDownService.countDownTime(this.vehicle.expirationTimeLeft).subscribe(contador => {
      this.contador = contador;
    });

    this.imgUrls = this.filterImageUrls(this.vehicle.imgUrls).map(url => this.toSmallImageUrl(url));
    if (this.imgUrls.length > 0) {
      this.vehicleImages = [this.imgUrls[0]];
    }
  }

  get hasMultipleImages(): boolean {
    return this.imgUrls.length > 1;
  }

  get baseUrlDir(): string {
    return this.isFastQuote ? '/cotacao-rapida/veiculos' : '../veiculos';
  }

  get fuel(): string {
    if (this.vehicle.fuel?.includes('GNV')) {
      return 'GNV';
    }
    return FuelEnum[this.vehicle.fuel];
  }

  get transmission(): string {
    return TransmissionEnum[this.vehicle.transmission];
  }

  toggleFavorite(event: Event): boolean {
    this.vehicle.favorite = !this.vehicle.favorite;
    if (this.vehicle.favorite) {
      this.dealerService.saveAsFavorite(this.vehicle.id, this.isFastQuote).subscribe();
    } else {
      this.dealerService.removeAsFavorite(this.vehicle.id, this.isFastQuote).subscribe();
    }
    event.stopPropagation();
    return false;
  }

  get slug(): string {
    return this.openService.getVehicleSlug(this.vehicle);
  }

  nextImg(event: Event): void {
    event.stopPropagation();
    this.ensureAllImagesLoaded();
    if (this.imgIndex < this.imgUrls.length - 1) {
      this.imgIndex++;
    }
  }

  prevImg(event: Event): void {
    event.stopPropagation();
    if (this.imgIndex > 0) {
      this.imgIndex--;
    }
  }

  private ensureAllImagesLoaded(): void {
    if (this.vehicleImages.length <= 1 && this.imgUrls.length > 1) {
      this.vehicleImages = [...this.imgUrls];
    }
  }

  private filterImageUrls(urls: string[] | undefined): string[] {
    return (urls ?? []).filter(url => CardVehicleHomeComponent.IMAGE_URL_PATTERN.test(url));
  }

  private toSmallImageUrl(imgUrl: string): string {
    if (!imgUrl.includes('img.autoarremate.com.br')) {
      return imgUrl;
    }

    const lastDot = imgUrl.lastIndexOf('.');
    if (lastDot === -1) {
      return imgUrl;
    }

    return imgUrl.substring(0, lastDot) + '_small' + imgUrl.substring(lastDot);
  }

}
